import React from "react";
import styles from "./About.module.css";
import GlobalIcon from "../../Assests/icons/svgforinfo.svg";
import ProcurementIcon from "../../Assests/icons/svgforinfo.svg";

import whatweOffer1 from "../../Assests/Images/whatweOffer1.png";
import whatweOffer2 from "../../Assests/Images/whatweOffer2.png";

const globalReachPoints = [
  {
    title: "Worldwide sourcing capabilities",
    description: "Access to suppliers across the globe for diverse needs.",
    icon: GlobalIcon,
  },
  {
    title: "Trusted supplier partnerships",
    description: "Strong relationships with reliable suppliers.",
    icon: GlobalIcon,
  },
  {
    title: "Industry-specific solutions",
    description: "Tailored solutions for unique industry requirements.",
    icon: GlobalIcon,
  },
];

const procurementPoints = [
  {
    title: "Cost Efficiency",
    description: "Minimize spending and eliminate excess stockpiling through strategic sourcing and inventory optimization.",
    icon: ProcurementIcon,
  },
  {
    title: "Reliable Distribution",
    description: "Minimize delays and improve operational efficiency with optimized logistics and distribution networks.",
    icon: ProcurementIcon,
  },
  {
    title: "Customized Supply Chain Management",
    description: "Solutions tailored to your industry's unique demands, ensuring seamless operations.",
    icon: ProcurementIcon,
  },
];

const WhatWeOffer = () => {
  return (
    <section id="what-we-offer" className={styles.offerSection}>
      <div className={styles.offerContainer}>
        {/* <div className={styles.sectionHeader}>
          <div className={styles.line}></div> */}
          <h2 className={styles.offerHeading}>What We Offer</h2>
        {/* </div> */}

        {/* Global Reach Section */}
        <div className={`${styles.offerGrid} ${styles.globalReachGrid}`}>
          <div className={`${styles.offerImageWrapper} ${styles.leftImage}`}>
            <img src={whatweOffer1} alt="Global Reach" className={styles.offerImage} />
          </div>
          <div className={styles.offerTextBlock}>
            <div className={styles.sectionHeader}>
              <div className={styles.line}></div>
              <h3 className={styles.offerSubHeading}>Global Reach, Local Expertise</h3>
            </div>
            <p className={styles.offerDescription}>
              With an extensive supplier network spanning North America, Europe, the Middle East, Africa, and Asia, we
              ensure access to high-quality products from industrial tools to specialized equipment. Our global reach
              helps guarantee competitive pricing and seamless delivery, wherever you operate.
            </p>
            <ul className={styles.bulletPointsContainer}>
              {globalReachPoints.map((point, index) => (
                <li key={index} className={styles.bulletPoint}>
                  <div className={styles.bulletIconWrapper}>
                    <img src={point.icon} alt="Icon" className={styles.bulletIcon} />
                  </div>
                  <div>
                    <span className={styles.bulletText}>{point.title}</span>
                    <p className={styles.bulletDescription}>{point.description}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Procurement Solutions Section */}
        <div className={`${styles.offerGrid} ${styles.procurementGrid}`}>
          <div className={styles.offerTextBlock}>
            <div className={styles.sectionHeader}>
              <div className={styles.line}></div>
              <h3 className={styles.offerSubHeading}>End-to-End Procurement Solutions</h3>
            </div>
            <p className={styles.offerDescription}>
              We handle every stage of the procurement process from sourcing and purchasing to logistics and
              distribution so you can stay focused on your core business priorities.
            </p>
            <ul className={styles.bulletPointsContainer}>
              {procurementPoints.map((point, index) => (
                <li key={index} className={styles.bulletPoint}>
                  <div className={styles.bulletIconWrapper}>
                    <img src={point.icon} alt="Icon" className={styles.bulletIcon} />
                  </div>
                  <div>
                    <span className={styles.bulletText}>{point.title}</span>
                    <p className={styles.bulletDescription}>{point.description}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <div className={`${styles.offerImageWrapper} ${styles.rightImage}`}>
            <img src={whatweOffer2} alt="Procurement Solutions" className={styles.offerImage} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatWeOffer;
